import React,{useState} from 'react';
import ClientsCarousel from './ClientsCarousel';
import HeaderBanner from './HeaderBanner';
import { VisionIcon, MissionIcon } from './Icon';
import WhyChooseCarousel from './WhyChooseCarousel';
import emailjs from "emailjs-com";
import { toast } from "react-toastify";

const OctopussJobs = () => {

    const [form, setForm] = useState({ Name: "", Mobile: "", Email: "", Message: "" });
    
        const sendEmail = (e: any) => {
            e.preventDefault();
            emailjs
                .send(
                    "service_yb3k31k",
                    "template_c57ipnh",
                    form,
                    "oUe5Px_prYF6Tyu0Y"
                )
                .then(() => {
                    toast.success("Applied Successfully Admin will contact you soon!", {
                        position: "top-center"
                    });
                }
                )
                .catch((err: any) => console.log(err));
        };
    

    return (
        <>
            <HeaderBanner heading={'Octopuss Jobs'} imagePath="./assets/images/banners/jobs.avif" />
            <section className="about about-1" id="about-1" style={{ marginTop: '30px' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-5">
                            <div className="about-img-holder">
                                <div className="about-img"><img className="img-fluid" src="assets/images/vision/vision.jpeg" alt="about Image" style={{ height: '490px' }} />
                                </div>
                            </div>
                            {/* <!-- End .about-img-holder--> */}
                        </div>
                        <div className="col-12 col-lg-7">
                            <div className="heading heading-11">
                                <div className="row">
                                    <div className="col-12">
                                        <p className="heading-with-border">Octopuss Jobs </p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-lg-12">
                                        <p className='octo-para'>
                                            Octopuss India is a trusted name in the field of recruitment and HR solutions, headquartered in Kolkata, India. With a vision to connect the right talent with the right opportunities, we specialize in delivering customized staffing solutions to businesses across various industries including IT, Non-IT, Healthcare, Education, Retail, FMCG, and more.
                                        {/* </p> */}
                                        {/* <p className='octo-para'> */}
                                            Established with a strong commitment to excellence and integrity, Octopuss India operates on a simple principle — to understand the unique hiring needs of every client and provide fast, effective, and reliable manpower solutions.
                                            Whether you're a startup or a well-established enterprise, our experienced team of recruiters is equipped to support all your hiring goals with precision.
                                        {/* </p> */}

                                        {/* <p className='octo-para'> */}
                                            We pride ourselves on our extensive candidate database, industry expertise, and client-centric approach. Our services include Permanent Hiring, Temporary Staffing, Bulk Recruitment, Executive Search, Freelance Recruiter Partnerships, and HR Outsourcing.
                                        </p>

                                        <p className='octo-para'>
                                            At Octopuss India, we believe that people are the true assets of any organization. That’s why we go beyond just filling vacancies — we build careers and create long-term partnerships.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- End .col-lg-6 --> */}
                    </div>
                    {/* <!-- End .row--> */}
                </div>
                {/* <!-- End .container--> */}
            </section>

            <section className="bleezy-about-page" style={{ marginBottom: '30px', background: '#f5f1f1', paddingTop: '30px' }}>
                <div className="container">
                    <div className="row">
                        <div className='container-card about-left'>
                            <div className='mission-vision-card'>
                                <h2 className='heading-without-border'><VisionIcon></VisionIcon> OUR VISION :</h2>
                                <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                                    “To be recognized as one of India’s most trusted and result-driven recruitment consultancies — a strategic partner that businesses rely on for growth and a gateway of opportunities for aspiring professionals across all industries.”
                                </p>
                            </div>
                            <div className='mission-vision-card'>
                                <h2 className='heading-without-border'><MissionIcon></MissionIcon> OUR MISION :</h2>
                                <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                                    “To empower organizations by delivering top-quality talent solutions and to help individuals build meaningful careers. At Octopuss India, we strive to provide reliable, timely, and customized recruitment services that create long-term value for both employers and job seekers.”
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="bleezy-about-page" style={{ marginBottom: '30px', background: '#f5f1f1', paddingTop: '30px', paddingBottom: '30px' }}>
                <div className="container">
                    <div className="col-12">
                        <div className='center-heading'>
                            <p className="heading-with-border">Why Choose Octopuss Job Services </p>
                        </div>
                    </div>
                    <WhyChooseCarousel />
                </div>
            </section>

            <section className="bleezy-about-page" style={{ marginBottom: '30px', background: '#f5f1f1', paddingTop: '30px', paddingBottom: '30px' }}>
                <div className="container">
                    <div className="col-12">
                        <div className='center-heading'>
                            <p className="heading-with-border">our happy clients </p>
                        </div>
                    </div>
                    <ClientsCarousel />
                </div>
            </section>

            <section className="" style={{ marginBottom: '30px', background: '#f5f1f1', paddingTop: '30px', paddingBottom: '30px' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-12 col-xl-12 col-xxl-12">
                            <div className="contact-card">
                                <div className="contact-body">
                                    <h5 className="card-heading" style={{ textAlign: 'center' }}>Apply Now</h5>
                                    <p className="card-desc" style={{ textAlign: 'center' }}>Our experts will reply you very soon</p>
                                    <form className="contactForm" method="post" onSubmit={sendEmail}>
                                        <div className="row">
                                            <div className="col-12 col-md-4">
                                                <input className="form-control" type="text" id="contact-name" name="contact-name" placeholder="Name" required={true} />
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <input className="form-control" type="email" id="contact-email" name="contact-email" placeholder="Email" required={true} />
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <input className="form-control" type="text" id="contact-phone" name="contact-phone" placeholder="Phone" required={true} />
                                            </div>
                                            <div className="col-12">
                                                <label>Upload Resume</label>
                                                <input type="file" className="form-control" id="contact-infos" placeholder="Upload" name="contact-infos" required={true}/>
                                            </div>
                                            <div className="col-12">
                                                <textarea className="form-control" id="contact-infos" placeholder="additional information" name="contact-infos" required={false}></textarea>
                                            </div>
                                            <div className="col-12">
                                                <button className="btn btn--secondary-dark justify-content-between" style={{ width: '200px' }}>Apply Now <i className="icon-arrow-right"></i></button>
                                            </div>
                                            <div className="col-12">
                                                <div className="contact-result"></div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                {/* <!-- End .contact-body --> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default OctopussJobs;